import sortBy from 'lodash-es/sortBy'

import { Episode } from '@lyrahealth-inc/shared-app-logic/src/models/episodes/Episodes'

import { episodeStates } from '../../../common/constants/appConstants'

// Shared so the provider-scoped and patient-scoped episode readers can't drift on the rule.
export const pickEpisode = (
  episodes: Episode[] | undefined,
  selectedClientId?: string | null,
  episodeId?: string,
): Episode | null => {
  if (!episodes || episodes.length === 0) {
    return null
  }

  if (episodeId) {
    return episodes.find((episode) => episode.id === episodeId) ?? null
  }

  const activeEpisode = episodes.find(
    (episode) => episode.state === episodeStates.IN_PROGRESS && episode.patient_id === selectedClientId,
  )
  if (activeEpisode) {
    return activeEpisode
  }

  return sortBy(episodes, (episode) => new Date(episode.start_date).getTime() * -1)[0] ?? null
}
